import { forwardRef } from 'react';

type Props = {
  children: any;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  type?: 'submit' | 'button';
  form?: any;
};

const Button =
  (className: string): any =>
  forwardRef((props: Props, ref: any): JSX.Element => {
    return (
      <button ref={ref} type={props.type || 'button'} form={props.form} className={`btn ${className} ${props.className || ''}`} onClick={props.onClick} disabled={props.disabled}>
        {props.children}
      </button>
    );
  });

export const Primary = Button('btn-lg btn-primary');
export const TertiaryGray = Button('btn-lg btn-tertiary');
export const Danger = Button('btn-lg btn-danger');
export const PrimarySmall = Button('btn-sm btn-primary');
export const Tertiary = Button('btn-lg btn-tertiary-primary');
export const TertiarySmall = Button('btn-sm btn-tertiary-primary');
export const TertiaryGraySmall = Button('btn-sm btn-tertiary');
export const LightBlack = Button('btn-lg btn-light-black');
export const LightBlackSmall = Button('btn-sm btn-light-black');